// Components
import Navbar from 'components/NavbarCompact'
import Router from '@/Router'
import Footer from 'components/Footer'
import GlobalSpinner from 'components/GlobalSpinner'
import NavigationLoader from 'components/NavigationLoader'



function App() {
  return (
    <div className='relative'>
      {/* Global Loading Spinner */}
      <GlobalSpinner />

      {/* Navigation Loader - triggers spinner on route changes */}
      <NavigationLoader />

      {/* Navbar */}
      <Navbar />

      {/* Content */}
      <Router />
      <Footer />
    </div>
  )
}

export default App
